export const trackWhatsAppClick = ({ cta, section, href }) => {
  const payload = { cta, section, href, page: window.location.pathname };
  try {
    window.posthog?.capture?.("whatsapp_cta_click", payload);
  } catch {}
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "whatsapp_cta_click", ...payload });
  } catch {}
  if (import.meta.env?.DEV) console.info("[tracking] whatsapp_cta_click", payload);
};

export const initWhatsAppTracking = () => {
  const onClick = (e) => {
    const a = e.target.closest('a[href*="wa.me"]');
    if (!a) return;
    const scoped = a.closest("section, header, footer");
    const section = scoped?.id || scoped?.dataset?.testid || "float/unknown";
    trackWhatsAppClick({ cta: a.dataset.testid || "unnamed", section, href: a.href.split("?")[0] });
  };
  document.addEventListener("click", onClick);
  return () => document.removeEventListener("click", onClick);
};
